import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../Components/assets/icons/a1.png";
import colunms from "../../Components/assets/icons/LINES.png";
import pen from "../../Components/assets/icons/pen.png";
import basket from "../../Components/assets/icons/basket.png";
import search1 from "../../Components/assets/icons/search.png";
import top from "../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../assets/icons/circle.png";
import rigth from "../assets/icons/rigth.png";
import save from "../assets/icons/save.png";
import cancel from "../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../Header/Header";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";
import { formatDate } from "../../utils/common";
import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../utils/context";
import { post } from "jquery";
import { postData } from "../../utils/api";
import ViewOffCanvance from "./ViewOffCanvance";
import ModalOrder from "../common/ModeOrder";
import ExportMethod from "../../utils/apis/ExportMethod";
import Pagination_Holder from "../common/Pagination_Holder/Pagination_Holder";
library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    userdata,
    usertype,
    IMG_URL,
  } = useContext(Context);

  console.log(usertype, "usertype");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [orderModel, setOrderModel] = useState(false);
  const [option, setOption] = useState();

  const [changeStatus, setChangeStatus] = useState();

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const [customerName, setCustomerName] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [searchOrderStatus, setSearchOrderSatatus] = useState("");
  const [searchPaymentStatus, setSearchPaymentSatatus] = useState("");

  const [searchDate, setSearchDate] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");

  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };
  const getDataAll = async () => {
    const response = await getData(
      `/bespoke-order?page=${onPageChange}&per_page=${perPage}&term=${search || ""
      }&customerNumber=${customerNumber || ""
      }&customerName=${customerName}&searchCategory=${searchCategory?.value || ""
      }&searchOrderStatus=${searchOrderStatus?.value || ""
      }&searchPaymentStatus=${searchPaymentStatus?.value || ""}&from=${searchDate || ""
      }&to=${searchDateTo || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    // customerName,
    // searchCategory,
    // searchOrderStatus,
    // searchPaymentStatus,
    // searchDateTo,
    // searchDate,
    // customerNumber,
    onPageChange,
  ]);

  useEffect(() => {
    console.log("searchPaymentStatus", searchPaymentStatus);
  }, [searchPaymentStatus]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/bespoke-order/${id}`);
    setChangeStatus(response);
  };

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);
  const [orderId, setOrderId] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };
  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/bespoke-order/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };
  const [category, setCategory] = useState({});
  const [orderStatus, setOrderStatus] = useState({});

  const GetAllCategory = async () => {
    const response = await getData("/allcategories/1");

    if (response?.success) {
      setCategory(await Select2Data(response?.data, "category_id"));
    }
  };

  const GetAllOrdderStatus = async () => {
    const response = await getData("/all-order-status");

    if (response?.success) {
      setOrderStatus(await Select2Data(response?.data, "order_status_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
    GetAllOrdderStatus();
  }, []);

  useEffect(() => {
    console.log("selectAllChecked", selectAllChecked);
  }, [selectAllChecked]);

  const ChangeStatusmodel = async (id, name) => {
    setOrderModel(true);
    setOrderId(id);
  };

  const ChangeStatusmodelCancel = () => {
    setOrderModel(false);
    setOrderId(null);
  };
  const handleChangeStatus = async (id) => {
    setOrderModel(false);
    try {
      if (selectAllChecked.length === 0) {
        alert("Please select at least one row");
        return; // Exit the function early if no rows are selected
      }

      const response = await postData("/bespoke-order/updateStatus", {
        selectedIds: selectAllChecked,
        newStatusId: orderId,
      });

      if (response?.success) {
        alert("Order status updated successfully:", response.data);
        getDataAll();
      }

      console.log("Order status updated successfully:", response.data);
    } catch (error) {
      console.error("Error updating order status:", error);
      // Handle errors if necessary
    }
  };

  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      console.log("user :-", response?.data);
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);
  const handleViewshow = async (id) => {
    console.log(id);
    await setview(id);
  };

  const handleDownload = async (invoice) => {
    try {
      // const response = await getData(`/bespoke-order/invoice-download/${id}`);

      const filePath = invoice;
      if (!filePath) {
        console.error("File path is undefined or null");
        return;
      }

      const url = `${IMG_URL}/${filePath}`;

      // Create an invisible link element and open the file in a new tab
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank"; // Open in a new tab
      a.rel = "noopener noreferrer"; // Recommended for security reasons
      a.click();
    } catch (error) {
      console.error("Error opening file:", error);
    }
  };

  const handleExportExcel = () => {
    const header = [
      { name: "Sr. No." },
      { name: "Customer Name" },
      { name: "Contact" },
      { name: "Email" },
      { name: "Delivery Address" },
      { name: "Delivery Date" },
      { name: "Gift Category" },
      { name: "Occasion" },
      { name: "Budget" },
      { name: "Quantity" },
      { name: "Packaging Preference" },
      { name: "Add-Ons" },
      { name: "Recipient Name" },
      { name: "Custom Text" },
      { name: "Font Style" },
      { name: "Order Reference" },
      { name: "Payment Mode" },
      { name: "Order Status" },
      { name: "Order Date" },
    ];

    const exportData = data?.data?.data?.map((d, index) => [
      index + 1,
      d?.name || "",
      `${d?.contact_no}` || "",
      d?.email || "",
      d?.delivery_address || "",
      // Delivery Date: preferred date name OR specific date
      d?.delivery_date_id
        ? d?.preferred_delivery_date?.name || ""
        : d?.delivery_date
          ? d.delivery_date.split("T")[0]
          : "",
      d?.category?.name || "",
      d?.occasion?.name || "",
      d?.budget ? `₹ ${Number(d.budget).toLocaleString("en-IN")}` : "",
      d?.quantity || "",
      d?.packaging_preference?.name || "",
      d?.add_ons || "",
      d?.recipient_name || "",
      d?.custom_text || "",
      d?.font_style || "",
      d?.order_reference || "",
      d?.payment_mode || "",
      d?.status === 1 ? "Pending" : "Completed",
      d?.createdAt ? d.createdAt.split("T")[0] : "",
    ]);

    const { content, type, name } = ExportMethod.excel(
      exportData,
      header,
      "Bespoke_Orders"
    );

    const blob = new Blob([content], { type });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = name;
    link.click();
  };
  console.log(data?.data, "data?.data data?.data");

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Orders"} link={"/employee/employee_details"} />
        <section className="AdvanceDashboard">
          <div className="row MainRowsec">
            <section className="Tabels tab-radio tab-radio mt-3">
              <div className="">
                {/* container */}
                <div className="row">
                  <div className="d-flex">
                    <div className="add me-3">
                      {/* {isAllow.includes(6) ? ( */}
                      {/* <Link
                          // to="/employee/employee_details/add"
                          type="button"
                          className="btn btn-add pe-3"
                        >
                          <div onClick={() => handleShow()}>
                            <img src={plus} className="plus me-2 ms-0" alt="" />
                            Add Product
                          </div>
                        </Link> */}
                      {/* ) : (
                        <></>
                      )} */}
                      <button
                        className="btn btn-columns dropdown-toggle"
                        tabindex="0"
                        aria-controls="DataTables_Table_0"
                        type="button"
                        onClick={handleExportExcel}
                      >
                        <span>Excel Export</span>
                      </button>
                    </div>

                    <div className="add d-flex">
                      <div className="dropdown">
                        <button
                          className="btn btn-columns dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img src={colunms} className="columns me-2 " alt="" />
                          Column Selection{" "}
                          <img src={top} className="top ms-1" alt="" />{" "}
                        </button>
                        <ul className="dropdown-menu">

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col1")}
                              href="#"
                            >
                              Sr. No.
                              {visible?.col1 ? (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col2")}
                              href="#"
                            >
                              Customer Name
                              {visible?.col2 ? (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col3")}
                              href="#"
                            >
                              Contact

                              {visible?.col3 ? (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col4")}
                              href="#"
                            >
                              Order Date
                              {visible?.col4 ? (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col5")}
                              href="#"
                            >
                              Delivery Date
                              {visible?.col5 ? (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col6")}
                              href="#"
                            >
                              Budget
                              {visible?.col6 ? (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col7")}
                              href="#"
                            >
                              Quantity
                              {visible?.col7 ? (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col8")}
                              href="#"
                            >
                              Payment Mode
                              {visible?.col8 ? (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col9")}
                              href="#"
                            >
                              Order Status
                              {visible?.col9 ? (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-2" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                          <li>
                            <Link
                              className="dropdown-item"
                              onClick={(event) => toggleColumn(event, "col10")}
                              href="#"
                            >
                              Action
                              {visible?.col10 ? (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye" />
                              ) : (
                                <FontAwesomeIcon className="ms-4" icon="fa-solid fa-eye-slash" />
                              )}
                            </Link>
                          </li>

                        </ul>
                      </div>

                      <div>
                        {usertype !== "Admin" ? (
                          <button
                            className="btn btn-columns dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              marginLeft: "5px",
                              backgroundColor: "green",
                            }}
                          >
                            <img src={colunms} className="columns me-2 " alt="" />
                            Change Order Status{" "}
                            <img src={top} className="top ms-1" alt="" />{" "}
                          </button>
                        ) : (
                          <></>
                        )}
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          {Object.keys(orderStatus).length > 0 &&
                            Object.entries(orderStatus).map(
                              ([id, status]) =>
                                status?.value !== 1 && (
                                  <button
                                    className="dropdown-item"
                                    key={id}
                                    onClick={() => ChangeStatusmodel(status.value)}
                                  >
                                    {status.label}{" "}
                                  </button>
                                )
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className="col-xxl-2 col-xl-2 col-lg-12 col-md-3 col-sm-4 col-12">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">entries</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-10 col-xl-10  col-lg-12  col-md-12 col-12">
                      <div className="row">
                        <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Customer Number"
                              id=""
                              value={customerNumber}
                              onChange={(e) => {
                                setCustomerNumber(e.target.value);
                                setonPageChange(1);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Customer Name"
                              id=""
                              value={customerName}
                              onChange={(e) => {
                                setCustomerName(e.target.value);
                                setonPageChange(1);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <Select
                              options={category}
                              placeholder="Select Category"
                              value={searchCategory}
                              onChange={(e) => {
                                setSearchCategory(e);
                                setonPageChange(1);
                              }}
                              classNamePrefix="searchCategory"
                            />
                          </div>
                        </div>
                        {/* <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <Select
                              options={orderStatus}
                              placeholder="Select Order Status"
                              value={searchOrderStatus}
                              onChange={(e) => {
                                setSearchOrderSatatus(e);
                                setonPageChange(1);
                              }}
                              classNamePrefix="searchCategory"
                            />
                          </div>
                        </div> */}

                        {/* <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <Select
                              options={[
                                { label: "Paid", value: "online" },
                                { label: "Unpaid", value: "cod" },
                              ]}
                              // value={searchPaymentStatus}
                              placeholder="Payment Status"
                              value={searchPaymentStatus}
                              onChange={(e) => {
                                setSearchPaymentSatatus(e);
                                setonPageChange(1);
                              }}
                              classNamePrefix="searchCategory"
                            />
                          </div>
                        </div> */}

                        <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <label className="form-label">From</label>
                            <input
                              max={new Date().toISOString().split("T")[0]}
                              type="date"
                              className="form-control"
                              placeholder="from"
                              value={searchDate}
                              onChange={(e) => {
                                setSearchDate(e.target.value);
                                setonPageChange(1);
                              }}
                              onInput={(e) => {
                                const inputValue = e.target.value;
                                const [year, month, day] =
                                  inputValue.split("-");
                                if (year && year.length > 4) {
                                  e.target.value = `${year.slice(0, 4)}-${month || ""
                                    }-${day || ""}`.replace(/-+$/, "");
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-sm-12 col-12  mb-3">
                          <div className="num me-2">
                            <label className="form-label">To</label>
                            <input
                              type="date"
                              className="form-control"
                              placeholder="to"
                              max={new Date().toISOString().split("T")[0]}
                              value={searchDateTo}
                              onChange={(e) => {
                                setSearchDateTo(e.target.value);
                                setonPageChange(1);
                              }}
                              onInput={(e) => {
                                const inputValue = e.target.value;
                                const [year, month, day] =
                                  inputValue.split("-");
                                if (year && year.length > 4) {
                                  e.target.value = `${year.slice(0, 4)}-${month || ""
                                    }-${day || ""}`.replace(/-+$/, "");
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-xxl-1 col-xl-1  col-lg-1  col-md-1 col-sm-2 col-3  my-auto">
                          <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div>
                        </div>

                        <div className="col-xxl-1 col-xl-1  col-lg-1  col-md-1 col-sm-2 col-3  my-auto">
                          <div className="Search-1">
                            <button
                              type="button"
                              onClick={() => {
                                setSearchPaymentSatatus("");
                                setSearchOrderSatatus("");
                                setSearchCategory("");
                                setCustomerName("");
                                setSearchDateTo("");
                                setSearchDate("");
                                setCustomerNumber("");
                                setReset(!reset);
                              }}
                              className="btn btn-reset"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr>
                          {visible.col1 && <th className="sr tax-name">Sr. No.</th>}
                          {visible.col2 && <th className="tax-name">Customer Name</th>}
                          {visible.col3 && <th className="tax-name">Contact</th>}
                          {visible.col4 && <th className="tax-name">Order Date</th>}
                          {visible.col5 && <th className="tax-name">Delivery Date</th>}
                          {visible.col6 && <th className="tax-name">Budget</th>}
                          {visible.col7 && <th className="tax-name">Quantity</th>}
                          {visible.col8 && <th className="tax-name">Payment Mode</th>}
                          {visible.col9 && <th className="tax-name">Status</th>}
                          {visible.col10 && <th className="tax-name">Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.data?.map((d, index) => (
                          <tr key={d?.id}>
                            {visible.col1 && <td>{++index}.</td>}
                            {visible.col2 && <td>{d?.name || "—"}</td>}
                            {visible.col3 && <td>{d?.contact_no || "—"}</td>}
                            {visible.col4 && <td>{d?.createdAt?.split("T")[0] || "—"}</td>}
                            {visible.col5 && (
                              <td>
                                {d?.delivery_date_id
                                  ? d?.preferred_delivery_date?.name || "—"
                                  : d?.delivery_date
                                    ? d.delivery_date.split("T")[0]
                                    : "—"}
                              </td>
                            )}
                            {visible.col6 && (
                              <td>{d?.budget ? `₹ ${Number(d.budget).toLocaleString("en-IN")}` : "—"}</td>
                            )}
                            {visible.col7 && <td>{d?.quantity || "—"}</td>}
                            {visible.col8 && <td>{d?.payment_mode || "—"}</td>}
                            {visible.col9 && (
                              <td>
                                <span className={`badge ${d?.status === 1 ? "bg-warning" : "bg-success"}`}>
                                  {d?.status === 1 ? "Pending" : "Completed"}
                                </span>
                              </td>
                            )}
                            {visible.col10 && (
                              <td>
                                <Link type="button" className="btn btn-add pe-3">
                                  <div onClick={() => handleViewshow(d.id)}>View</div>
                                </Link>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}
      {orderModel ? (
        <ModalOrder
          handleChangeStatus={handleChangeStatus}
          handleClose={ChangeStatusmodelCancel}
          setShow={setShowAdd}
          show={orderModel}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          id={view}
        />
      ) : (
        ""
      )}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
